import ArrowTopGreen from './images/icon-arrow-top-green.svg';
import ArrowBottomRed from './images/icon-arrow-bottom-red.svg';
import ArrowTopRed from './images/icon-arrow-top-red.svg';
import ArrowBottomGreen from './images/icon-arrow-bottom-green.svg';

import './styles.css';

export default function Line({label, value, firstAttemptValue}) {
  let formattedValue = value;
  if(label === 'Accuracy') {
    formattedValue = `${(value * 100).toFixed(2)}%`;
  } else if(label === 'Average Time') {
    formattedValue = <span>{value} <span className="small">seconds</span></span>;
  }

  const arrowImage = firstAttemptValue > 0
    ? label === 'Accuracy'
      ? firstAttemptValue > value
        ? ArrowBottomRed
        : ArrowTopGreen
    : label === 'Average Time'
      ? firstAttemptValue > value
        ? ArrowBottomGreen
        : ArrowTopRed
      : null
    : null;

  return (
    <div className="summary-line">
      <span className="label">{label}</span>
      <span className="value">
        {formattedValue}
        {
            arrowImage && (
              <img src={arrowImage} alt="Progress" className="progress-arrow-icon" />
            )
          }
      </span>
    </div>
  );
}
